export default "__VITE_ASSET__2d87a70a__"